import Joi from "joi";
import { customMessages } from "./messages";

function ValidatePurchase(purchase) {
  const schema = Joi.object({
    idFornecedor: Joi.string().uuid({ version: 'uuidv4' }).required().messages({
      'string.base': '(Fornecedor) deve ser preenchido.',
      'string.empty': '(Fornecedor) deve ser preenchido.',
      'string.guid': '(Fornecedor) deve ser preenchido.',
      'any.required': '(Fornecedor) deve ser preenchido.'
    }).required().messages(customMessages.idFornecedor),
    dataCompra: Joi.date().required().messages(customMessages.dataCompra),
  }).unknown(true)

  const { error } = schema.validate(purchase, { abortEarly: false })

  if (error?.details && error?.details.length) {
    const errors = error?.details.map(erro => {
      if (erro?.message || erro?.path[0]) {
        if (erro.path.length > 1) {
          return {
            message: erro?.message,
            keyError: erro?.path[1],
            type: erro.type.split('.')[1]
          }
        }

        return {
          message: erro?.message,
          keyError: erro?.path[0],
          type: erro.type.split('.')[1]
        }
      }
    })

    return errors
  }
}

export { ValidatePurchase }